// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"Canvas_canvasContainer__1WarM","canvas":"Canvas_canvas__YrU8X"};